import { useState } from 'react'
import { KTIcon } from '../../../../../../_metronic/helpers'

const PasswordFormField = ({ formik, label, name, ml = '23rem', required = false }) => {
  const [showPassword, setShowPassword] = useState(false)

  const handleShowPassword = () => {
    setShowPassword(!showPassword)
  }
  return (
    <div className='fv-row mb-0'>
      <label
        htmlFor='confirmpassword'
        className={`${required ? 'required' : ''} form-label fs-6 fw-bolder mb-3`}
      >
        {label}
      </label>
      <input
        type={showPassword ? 'text' : 'password'}
        className='form-control form-control-lg form-control-solid '
        id={name}
        {...formik.getFieldProps(name)}
        style={{
          backgroundColor: 'white !important',
          border: '1px solid #ddd',
          WebkitBoxShadow: '0 0 0 1000px white inset',
          WebkitTextFillColor: 'black'
        }}
      />
      <div style={{ marginLeft: ml, marginTop: '-39px' }} onClick={handleShowPassword}>
        <KTIcon iconName={showPassword ? 'eye-slash' : 'eye'} className='fs-2hx' />
      </div>
      {formik.errors[name] && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>{formik.errors[name]}</div>
        </div>
      )}
    </div>
  )
}

export default PasswordFormField
